import { Schedule } from 'app/modules/masters/schedule-master/models/schedule.model';

export interface ScheduleState {
  schedules: Schedule[];
  loading: boolean;
  error: any;
  selectedSchedule: Schedule | null;
  nameExists: boolean | null;
  sortBy: 'createdAt' | 'name' | 'color' | 'messageOnSale' | 'doNotComeInSR' | 'prescriptionRequired';
  sortOrder: 'asc' | 'desc';
  /** Server-side list search (name contains) */
  listSearch: string;
  /** all | active | inactive — default `all` for master list (inactive rows greyed) */
  scheduleStatus: 'all' | 'active' | 'inactive';
}

export const initialScheduleState: ScheduleState = {
  schedules: [],
  loading: false,
  error: null,
  selectedSchedule: null,
  nameExists: false,
  sortBy: 'createdAt',
  sortOrder: 'desc',
  listSearch: '',
  scheduleStatus: 'all',
};
